// English title overrides — only for ids whose English title differs from the
// French one shown by default (falls back to CatalogEntry.title otherwise).
export const TITLE_EN: Record<string, string> = {
  cap1: 'Captain America: The First Avenger',
  hulk: 'The Incredible Hulk',
  avengers1: 'The Avengers',
  thor2: 'Thor: The Dark World',
  cap2: 'Captain America: The Winter Soldier',
  gotg1: 'Guardians of the Galaxy',
  gotg2: 'Guardians of the Galaxy Vol. 2',
  avengers2: 'Avengers: Age of Ultron',
  cap3: 'Captain America: Civil War',
  pun_s1: 'The Punisher (Netflix)',
  spiderman1: 'Spider-Man: Homecoming',
  thor3: 'Thor: Ragnarok',
  antman2: 'Ant-Man and the Wasp',
  pun_s2: 'The Punisher (Netflix)',
  avengers4: 'Avengers: Endgame',
  falcon: 'The Falcon and the Winter Soldier',
  farfromhome: 'Spider-Man: Far From Home',
  eternals: 'Eternals',
  shangchi: 'Shang-Chi and the Legend of the Ten Rings',
  nowayhome: 'Spider-Man: No Way Home',
  thor4: 'Thor: Love and Thunder',
  shehulk: 'She-Hulk: Attorney at Law',
  wakandaforever: 'Black Panther: Wakanda Forever',
  quantumania: 'Ant-Man and the Wasp: Quantumania',
  gotg3: 'Guardians of the Galaxy Vol. 3',
  marvels: 'The Marvels',
  x2: 'X2: X-Men United',
  xlaststand: 'X-Men: The Last Stand',
  xorigins: 'X-Men Origins: Wolverine',
  xfirstclass: 'X-Men: First Class',
  thewolverine: 'The Wolverine',
  xdofp: 'X-Men: Days of Future Past',
  xapocalypse: 'X-Men: Apocalypse',
  newmutants: 'The New Mutants',
  yfns1: 'Your Friendly Neighborhood Spider-Man',
  bravenewworld: 'Captain America: Brave New World',
  daredevil1: 'Daredevil: Born Again',
  fantasticfour: 'The Fantastic Four: First Steps',
  daredevil2: 'Daredevil: Born Again',
  punisher: 'The Punisher: One Last Kill',
  brandnewday: 'Spider-Man: Brand New Day',
  yfns2: 'Your Friendly Neighborhood Spider-Man',
  doomsday: 'Avengers: Doomsday',
  daredevil3: 'Daredevil: Born Again',
  secretwars: 'Avengers: Secret Wars',
  xmenreboot: 'X-Men (2028)',
};
